module.exports = __webpack_public_path__ + "assets/img/2c4e281dbae9466ce02165a8c4e48f47.svg";